export const SELECTED_SHOW_STORAGE_KEY = "story37.selectedShow";
export const SELECTED_SHOW_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function parseStoredShowId(value: string | null | undefined) {
  const showId = Number(value);
  return Number.isInteger(showId) && showId > 0 ? showId : undefined;
}
